module.exports = __webpack_public_path__ + "static/media/level-down-alt.9495d881.svg";